// extracted by mini-css-extract-plugin
export default {"button":"tsUCmW17uZGSXRRJL1Zg","selected":"av0OoF4GyIxZ5ZkSGhaD"};